// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"572b70cb","549":"b8adff72","632":"bb898c55","664":"60c7d2a3","683":"ec63ef2d","735":"60720f33","816":"0d764ac1","822":"28665be8","865":"36cfb0c3","948":"a644c6cd","955":"21e7c0fc"}[chunkId] + ".chunk.js";
};